import React from "react";
import sIcon1 from "../../images/icon/ab-page-icon01.svg";
import sIcon2 from "../../images/icon/ab-page-icon02.svg";
import sIcon3 from "../../images/icon/ab-page-icon03.svg";
import sIcon4 from "../../images/icon/ab-page-icon04.svg";

const FeaturesSection = () => {
  return (
    <section className="fanfact pt-125 pb-125">
      <div className="container">
        <div className="ap-feature_wrap">
          <div className="row mt-none-30">

            {/* FEATURE 1 */}
            <div className="col-lg-3 col-md-6 mt-30">
              <div
                className="ap-feature-item wow fadeInUp"
                data-wow-delay="0ms"
                data-wow-duration="600ms"
              >
                <div className="xb-item--icon">
                  <img src={sIcon1} alt="" />
                </div>
                <h4 className="xb-item--title">Industry-Led Conferences</h4>
                <p className="xb-item--content">
                  We design and deliver focused conferences that bring together
                  decision-makers, innovators, and industry leaders.
                </p>
              </div>
            </div>

            {/* FEATURE 2 */}
            <div className="col-lg-3 col-md-6 mt-30">
              <div
                className="ap-feature-item wow fadeInUp"
                data-wow-delay="100ms"
                data-wow-duration="600ms"
              >
                <div className="xb-item--icon">
                  <img src={sIcon2} alt="" />
                </div>
                <h4 className="xb-item--title">Future-Focused Topics</h4>
                <p className="xb-item--content">
                  Our events explore real-world applications of AI, data,
                  digital transformation, and emerging technologies.
                </p>
              </div>
            </div>

            {/* FEATURE 3 */}
            <div className="col-lg-3 col-md-6 mt-30">
              <div
                className="ap-feature-item wow fadeInUp"
                data-wow-delay="200ms"
                data-wow-duration="600ms"
              >
                <div className="xb-item--icon">
                  <img src={sIcon3} alt="" />
                </div>
                <h4 className="xb-item--title">Global Virtual Delivery</h4>
                <p className="xb-item--content">
                  We run high-quality virtual conferences that connect global
                  audiences without geographic limitations.
                </p>
              </div>
            </div>

            {/* FEATURE 4 */}
            <div className="col-lg-3 col-md-6 mt-30">
              <div
                className="ap-feature-item wow fadeInUp"
                data-wow-delay="300ms"
                data-wow-duration="600ms"
              >
                <div className="xb-item--icon">
                  <img src={sIcon4} alt="" />
                </div>
                <h4 className="xb-item--title">Execution Excellence</h4>
                <p className="xb-item--content">
                  From agenda design to speaker coordination, we focus on
                  clarity, quality, and seamless execution.
                </p>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
